import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { CampaingsTable } from "../../../UI/Users/Campaign/CampaingsTable";

const CampaignsPanel = () => {
  return (
    <div>
      <PanelHead title="Email Campaign" />
      <PanelBody content={<CampaingsTable />} />
    </div>
  );
};

export default React.memo(CampaignsPanel);
